import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  cardStyle: {
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 16,
    boxShadow: '0px 2px 8px rgba(16, 30, 54, 0.04)',
    padding: theme.spacing(3),
    minWidth: 220,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: 120,
    margin: theme.spacing(0.5),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      minWidth: 0,
    },
  },
  titleHeading: {
    marginBottom: theme.spacing(1),
    width: '100%',
  },
  contentWrapper: {
    marginTop: theme.spacing(1),
    width: '100%',
  },
  buttonSkeleton: {
    borderRadius: 10,
    marginLeft: theme.spacing(2),
  },
}));
